// extracted by mini-css-extract-plugin
export var item = "item-module--item--21AVy";
export var iconWrap = "item-module--iconWrap--3QkjS";
export var title = "item-module--title--3J1Kd";